import { ArrowBackIcon } from "@chakra-ui/icons";
import { Box, Button } from "@chakra-ui/react";
import { currencyFormat } from "@kg-pos/common";
import {
  StoreTableResponse,
  useCreateInitialMutation,
  useGetInitialsByStoreIdQuery,
} from "__generated__/graphql";
import { ErrorLayout } from "components/layouts/error";
import { MainTable } from "components/molecules/main-table";
import { InitialForm } from "components/organisms/initial-form";
import { StoreContext } from "contexts/store.context";
import { InitialSubmit } from "interfaces";
import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { routeConstants } from "routes";

const columns = [
  {
    Header: "名称",
    accessor: "name",
  },
  {
    Header: "金額",
    accessor: "price",
    Cell: (props: any) => <div>{currencyFormat(props.value)}</div>,
  },
  {
    Header: "説明",
    accessor: "description",
  },
];

export const InitialLayout: React.VFC = () => {
  const { push } = useHistory();
  const [isForm, setForm] = useState<boolean>(false);
  const { storeId } = useContext(StoreContext);
  const { loading, error, data, refetch } = useGetInitialsByStoreIdQuery({
    variables: { storeId },
    fetchPolicy: "cache-and-network",
  });
  const [createInitial] = useCreateInitialMutation();

  const backToTable = (): void => {
    setForm(false);
    void refetch();
  };

  const handleClick = (row: StoreTableResponse): void =>
    push(`${routeConstants.initials}/${row.id}?storeId=${storeId}`);

  const submit = async (input: InitialSubmit): Promise<void> => {
    await createInitial({ variables: { storeId, ...input } });
  };

  if (loading) return null;
  if (error) return <ErrorLayout />;

  return (
    <>
      {isForm ? (
        <Box>
          <ArrowBackIcon mb="6" onClick={backToTable} className="cursor-pointer" />
          <InitialForm backToTable={backToTable} submit={submit} />
        </Box>
      ) : (
        <>
          <Button colorScheme="blue" mb={6} onClick={() => setForm(true)}>
            初回を登録する
          </Button>
          <MainTable
            data={data?.initialsByStoreId ?? []}
            columns={columns}
            handleClick={handleClick}
          />
        </>
      )}
    </>
  );
};
